import React, { useState, useRef, useEffect, useCallback } from 'react';
import { TagBox } from 'devextreme-react/tag-box';
import { groupBy } from '../../utils/miscUtil';

export default function SIFFilter(props) {
  const activitiesRef = useRef(null);

  const [reportData, setReportData] = useState();
  const [areaData, setAreaData] = useState();
  const [selectedAreas, setSelectedAreas] = useState([]);
  const [disciplineData, setDisciplineData] = useState();
  const [selectedDiscipline, setSelectedDiscipline] = useState([]);
  const [activitiesData, setActivitiesData] = useState();
  const [selectedActivities, setSelectedActivities] = useState([]);
  const [availableActivities, setAvailableActivities] = useState([]);
  const [factorsData, setFactorsData] = useState();
  const [selectedFactors, setSelectedFactors] = useState([]);
  const [fvsIData, setFvsIData] = useState(null);
  const [selectedPotVsAct, setSelectedPotVsAct] = useState([]);
  const [potVsActData, setPotVsActData] = useState(null);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [categoriesData, setCategoriesData] = useState(null);
  const [selectedTimeOfDay, setSelectedTimeOfDay] = useState([]);
  const [timeOfDayData, setTimeOfDayData] = useState(null);
  const [selectedFvsI, setSelectedFvsI] = useState([]);
  const [employmentStatusData, setEmploymentStatusData] = useState(null);
  const [selectedEmploymentStatus, setSelectedEmploymentStatus] = useState([]);

  useEffect(() => {
    if (!props.data) {
      return
    }
    if (!props.data.length) {
      return
    }
    var fd = []
    for (var i = 0; i<props.data.length; i++) {
      var timestamp = Date.parse(props.data[i]['DATE OF EVENT (m/d/yyyy)']);
      var dateObject = new Date(timestamp);
      var clone = structuredClone(props.data[i]);
      clone['DATE OF EVENT (m/d/yyyy)'] = dateObject;
      if (dateObject>=props.startDate && dateObject<=props.endDate) {
        fd.push(clone)
      }
    }
    setReportData(fd);
    props.onFilteredDataChanged([...fd]);
    fd = groupBy(props.data, 'Area/Basin')
    fd = Object.keys(fd).map((key) => ({name: key}));
    fd = fd.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
    setAreaData(fd);
    setSelectedAreas(fd.map((item) => item.name))

    fd = groupBy(props.data, 'Discipline of Activity at Time of Event')
    let fd3 = {}
    for (const key in fd) {
      let fd2 = groupBy(fd[key], 'Activity at Time of Event')
      fd3[key] = Object.keys(fd2).map((key) => ({name: key}));
    }
    setActivitiesData(fd3);
    fd = Object.keys(fd).map((key) => ({name: key}));
    fd = fd.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
    setDisciplineData(fd);
    setSelectedDiscipline(fd.map((item) => item.name));

    fd = groupBy(props.data, 'Primary Causal Factors')
    fd = Object.keys(fd).map((key) => ({name: key}));
    fd = fd.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
    setFactorsData(fd);
    setSelectedFactors(fd.map((item) => item.name));

    //fd = groupBy(props.data, 'Potential or Actual SIF')
    //fd = Object.keys(fd).map((key) => ({name: key}));
    fd = [{name: 'Potential'}, {name: 'Actual'}];
    fd = fd.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
    setPotVsActData(fd);
    setSelectedPotVsAct(fd.map((item) => item.name));

    fd = groupBy(props.data, 'SIF CATEGORY')
    fd = Object.keys(fd).map((key) => ({name: key}));
    fd = fd.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
    setCategoriesData(fd);
    setSelectedCategories(fd.map((item) => item.name));

    fd = groupBy(props.data, 'Time of Event')
    fd = Object.keys(fd).map((key) => ({name: key}));
    fd = fd.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
    setTimeOfDayData(fd);
    setSelectedTimeOfDay(fd.map((item) => item.name));

    if (props.showFatalVsInjury) {
      fd = groupBy(props.data, 'Fatality Injury')
      fd = Object.keys(fd).map((key) => ({name: key}));
      fd = fd.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
      setFvsIData(fd);
      setSelectedFvsI(fd.map((item) => item.name));
    }

    if (props.showEmploymentStatus) {
      fd = groupBy(props.data, 'Employment Status')
      fd = Object.keys(fd).map((key) => ({name: key}));
      fd = fd.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
      setEmploymentStatusData(fd);
      setSelectedEmploymentStatus(fd.map((item) => item.name));
    }
  }, [props.data])

  const onAreasSelectedChanged = useCallback((e) => {
    if (e.value.length === 0) {
      setSelectedAreas(areaData.map((item) => item.name))
    } else {
      setSelectedAreas(e.value)
    }
  }, [areaData]);

  const onDisciplineSelectedChanged = useCallback((e) => {
    if (e.value.length === 0) {
      setSelectedDiscipline(disciplineData.map((item) => item.name))
      setSelectedActivities([]);
      setAvailableActivities([]);
      activitiesRef.current?.instance().clear();
    } else {
      setSelectedDiscipline(e.value)
      let fd = [];
      for (var i=0; i<e.value.length; i++) {
        fd.push(...activitiesData[e.value[i]])
      }
      setAvailableActivities(fd);
      setSelectedActivities(fd.map((item) => item.name));
    }
  }, [disciplineData, activitiesData, activitiesRef]);

  const onActivitySelectedChanged = useCallback((e) => {
    if (!availableActivities) {
      return
    }
    if (e.value.length === 0) {
      setSelectedActivities(availableActivities.map((item) => item.name))
    } else {
      setSelectedActivities(e.value)
    }
  }, [availableActivities]);

  const onFactorsSelectedChanged = useCallback((e) => {
    if (e.value.length === 0) {
      setSelectedFactors(factorsData.map((item) => item.name))
    } else {
      setSelectedFactors(e.value)
    }
  }, [factorsData]);

  const onPotVsActSelectedChanged = useCallback((e) => {
    if (e.value.length === 0) {
      setSelectedPotVsAct(potVsActData.map((item) => item.name))
    } else {
      setSelectedPotVsAct(e.value)
    }
  }, [potVsActData]);

  const onCategoriesSelectedChanged = useCallback((e) => {
    if (e.value.length === 0) {
      setSelectedCategories(categoriesData.map((item) => item.name))
    } else {
      setSelectedCategories(e.value)
    }
  }, [categoriesData]);

  const onFvsISelectedChanged = useCallback((e) => {
    if (e.value.length === 0) {
      setSelectedFvsI(fvsIData.map((item) => item.name))
    } else {
      setSelectedFvsI(e.value)
    }
  }, [fvsIData]);

  const onEmploymentStatusSelectedChanged = useCallback((e) => {
    if (e.value.length === 0) {
      setSelectedEmploymentStatus(employmentStatusData.map((item) => item.name))
    } else {
      setSelectedEmploymentStatus(e.value)
    }
  }, [employmentStatusData]);

  const onTimeOfDaySelectedChanged = useCallback((e) => {
    if (e.value.length === 0) {
      setSelectedTimeOfDay(timeOfDayData.map((item) => item.name))
    } else {
      setSelectedTimeOfDay(e.value)
    }
  }, [timeOfDayData]);

  useEffect(() => {
    if (!reportData) {
      return
    }
    var fd = [...reportData]
    if (selectedAreas.length) {
      fd = fd.filter(item => selectedAreas.includes(item['Area/Basin']));
    }
    if (selectedDiscipline.length) {
      fd = fd.filter(item => selectedDiscipline.includes(item['Discipline of Activity at Time of Event']));
    }
    if (availableActivities.length) {
      fd = fd.filter(item => selectedActivities.includes(item['Activity at Time of Event']));
    }
    if (selectedFactors.length) {
      fd = fd.filter(item => selectedFactors.includes(item['Primary Causal Factors']));
    }
    if (selectedPotVsAct.length) {
      if (selectedPotVsAct.includes('Potential') && selectedPotVsAct.includes('Actual')) {
        //do nothing - no need to filter when both selected
      } else {
        if (selectedPotVsAct.includes('Potential')) {
          fd = fd.filter(item => ((parseInt(item['Number of Fatalities']) || 0)+(parseInt(item['Number of Serious Injuries']) || 0)===0))
        }
        if (selectedPotVsAct.includes('Actual')) {
          fd = fd.filter(item => ((parseInt(item['Number of Fatalities']) || 0)+(parseInt(item['Number of Serious Injuries']) || 0)>0))
        }
      }
      /*fd = [{name: 'Potential'}, {name: 'Actual'}];
      fd = fd.filter(item => selectedPotVsAct.includes(item['Potential or Actual SIF']));*/
    }
    if (selectedCategories.length) {
      fd = fd.filter(item => selectedCategories.includes(item['SIF CATEGORY']));
    }
    if (selectedTimeOfDay.length) {
      fd = fd.filter(item => selectedTimeOfDay.includes(item['Time of Event']));
    }

    if (props.showFatalVsInjury && selectedFvsI.length) {
      fd = fd.filter(item => selectedFvsI.includes(item['Fatality Injury']));
    }
    if (props.showEmploymentStatus && selectedEmploymentStatus.length) {
      fd = fd.filter(item => selectedEmploymentStatus.includes(item['Employment Status']));
    }
    props.onFilteredDataChanged([...fd]);
  }, [selectedAreas, selectedDiscipline, selectedActivities, availableActivities, selectedTimeOfDay, selectedFactors, selectedPotVsAct, selectedCategories, selectedFvsI, selectedEmploymentStatus, reportData]);


  return (
    <div>
      <div className="row">
      {props.showArea && <div className="col-6">
      <TagBox
        className="w-100"
        dataSource={areaData}
        valueExpr="name"
        displayExpr="name"
        showSelectionControls={true}
        label="Area"
        labelMode="floating"
        multiline={false}
        maxDisplayedTags={1}
        onValueChanged={onAreasSelectedChanged}
      />
      </div>}
      {props.showPrimaryFactor && <div className="col-6">
      <TagBox
        className="w-100"
        dataSource={factorsData}
        valueExpr="name"
        displayExpr="name"
        showSelectionControls={true}
        label="Primary Causal Factors"
        labelMode="floating"
        multiline={false}
        maxDisplayedTags={1}
        onValueChanged={onFactorsSelectedChanged}
      />
      </div>}
      {props.showDisciplines && <div className="col-6">
      <TagBox
        className="w-100"
        dataSource={disciplineData}
        valueExpr="name"
        displayExpr="name"
        showSelectionControls={true}
        label="Discipline"
        labelMode="floating"
        multiline={false}
        maxDisplayedTags={1}
        onValueChanged={onDisciplineSelectedChanged}
      />
      </div>}
      {props.showDisciplines && props.showActivities && <div className="col-6">
      <TagBox
        ref={activitiesRef}
        className="w-100"
        dataSource={availableActivities}
        valueExpr="name"
        displayExpr="name"
        showSelectionControls={true}
        label="Activity"
        labelMode="floating"
        multiline={false}
        maxDisplayedTags={1}
        noDataText="Select a discipline first"
        onValueChanged={onActivitySelectedChanged}
      />
      </div>}
      {props.showPotentialActual && <div className="col-6">
      <TagBox
        className="w-100"
        dataSource={potVsActData}
        valueExpr="name"
        displayExpr="name"
        showSelectionControls={true}
        label="Potential/Actual"
        labelMode="floating"
        multiline={false}
        maxDisplayedTags={1}
        onValueChanged={onPotVsActSelectedChanged}
      />
      </div>}
      {props.showCategories && <div className="col-6">
      <TagBox
        className="w-100"
        dataSource={categoriesData}
        valueExpr="name"
        displayExpr="name"
        showSelectionControls={true}
        label="Categories"
        labelMode="floating"
        multiline={false}
        maxDisplayedTags={1}
        onValueChanged={onCategoriesSelectedChanged}
      />
      </div>}
      {props.showTimeOfDay && <div className="col-6">
      <TagBox
        className="w-100"
        dataSource={timeOfDayData}
        valueExpr="name"
        displayExpr="name"
        showSelectionControls={true}
        label="Time of Day"
        labelMode="floating"
        multiline={false}
        maxDisplayedTags={1}
        onValueChanged={onTimeOfDaySelectedChanged}
      />
      </div>}

      {props.showFatalVsInjury && <div className="col-6">
      <TagBox
        className="w-100"
        dataSource={fvsIData}
        valueExpr="name"
        displayExpr="name"
        showSelectionControls={true}
        label="Fatal/Injury"
        labelMode="floating"
        multiline={false}
        maxDisplayedTags={1}
        onValueChanged={onFvsISelectedChanged}
      />
      </div>}
      {props.showEmploymentStatus && <div className="col-6">
      <TagBox
        className="w-100"
        dataSource={employmentStatusData}
        valueExpr="name"
        displayExpr="name"
        showSelectionControls={true}
        label="Employment Status"
        labelMode="floating"
        multiline={false}
        maxDisplayedTags={1}
        onValueChanged={onEmploymentStatusSelectedChanged}
      />
      </div>}
      </div>

      {props.showArea && props.showPrimaryFactor && props.showDisciplines && props.showActivities &&
        props.showPotentialActual && props.showCategories && props.showTimeOfDay && props.showFatalVsInjury && props.showEmploymentStatus &&
        <hr className="mt-1 mb-2"></hr>}


    </div>
  );
}
